import React, {useEffect, useState} from 'react'
import {KTIcon} from "../../../../_metronic/helpers";
import {Link} from "react-router-dom";
import {MyTooltip} from "../tooltip/Tooltip";
import {IBannerItem} from "../../../types/banner";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_BANNER} from "../../../mock/URLs";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import moment from "moment";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import {updateBanner} from "../../../services/bannerSvc";

type BannerCardProps = {
  banner: IBannerItem
  refetchBanner: () => void
}

export const BannerCard = ({banner, refetchBanner}: BannerCardProps) => {
  const {openDeleteModal} = useDeleteModal();
  const [isActive, setIsActive] = useState(banner.is_active);

  useEffect(() => {
    setIsActive(banner.is_active);
  }, [banner.is_active]);

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_BANNER, id, refetchBanner);
  };

  const handleCheckboxChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newIsActive = e.target.checked;
    setIsActive(newIsActive);
    await updateBanner(banner.id, {is_active: newIsActive});
  };

  return (
      <div>
        <div className="border rounded-4 p-0">
          <div className={"px-5 rounded-4"}>
            <img
                data-fancybox="gallery"
                data-caption={banner?.link}
                loading={"lazy"}
                src={banner ? imgBaseUrl(banner?.image!) : PLACEHOLDER_IMAGE_URL}
                className={"w-100 mt-5 mh-200px object-fit-cover rounded-4"}
                alt={banner?.link}
            />
            <span className={"text-muted mt-5 d-block"}>
            {moment(banner?.created_at).format("DD.MM.YYYY HH:mm")}
          </span>
          </div>

          <div className={"p-3 d-flex align-items-center justify-content-between"}>
            <Link to={`/banner/update/${banner?.id}`} className={"btn btn-sm btn-light-primary"}>
              <KTIcon iconName={"pencil"} className={"fs-4"}/>
              Tahrirlash
            </Link>

            <MyTooltip title={"Holatni aktivlashtirish"} position="top">
              <div className="form-check form-check-solid form-switch fv-row">
                <input
                    className="form-check-input w-45px h-30px"
                    type="checkbox"
                    name={"is_active"}
                    checked={isActive}
                    onChange={handleCheckboxChange}
                />
                <label className="form-check-label"></label>
              </div>
            </MyTooltip>


            <button
                className="btn btn-icon btn-danger btn-sm me-1"
                onClick={() => {
                  handleDeleteClick(banner.id);
                }}
            >
              <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"}/>
            </button>
          </div>
        </div>
      </div>
  );
};
